<micro-select-combo #sel
              placeholder="Account Transaction Status"
              [mode]="mode"
              [(id)]="accountTransactionStatusId"
              (idChange)="change($event)"
              [options]="options"
              [required]="required"
              [disabled]="disabled"
>
</micro-select-combo>
